module.exports = __webpack_public_path__ + "img/btn_more_blu.efaee267.png";